import { Box, Stack } from '@mui/material';
import * as React from 'react';
import Service from '../../util/Service';
import ContentPage from '../page/portal/ContentPage';

const LinhaContent = ({  edit, darkMode, pagina}) => {

    const [linhas, setLinhas] = React.useState([]);

    React.useEffect(() => {
        buscaPaginaRoot();

    }, [])

    function buscaPaginaRoot() {
        Service.GET('/api/paginaHtml/buscaPorNome/'+ pagina.layout.linha).then(r => {
            if (r && r.length > 0) {
                console.log(r, ">>>>>>>>", pagina);
                setLinhas(r.sort((a,b) => a.index - b.index));
            }
        });
    }

    return (
        <Stack spacing={2}>
            {linhas && linhas?.map( (linha,i) => (
                < ContentPage key={linha.id+"_"+i} edit={edit} darkMode={darkMode} pagina={linha} />
            ) )}
        </Stack>
    )
}

export default LinhaContent;
